import { render, staticRenderFns } from "./ProductBaike.vue?vue&type=template&id=08b61368&scoped=true&"
import script from "./ProductBaike.vue?vue&type=script&lang=js&"
export * from "./ProductBaike.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaike.vue?vue&type=style&index=0&id=08b61368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b61368",
  null
  
)

export default component.exports